import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Icons from './icons/Icons';
import { FlexCol, FlexRow } from './FlexGrid';
import { passwordCriteriaCheck } from '../validation/PassCriteriaValidation';


export default class PasswordStrengthIndicator extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            strength: 0,
            criteria: passwordCriteriaCheck('')
        };
    }

    componentDidUpdate(prevProps) {
        const { password } = this.props;

        if (password !== prevProps.password) {
            const criteria = passwordCriteriaCheck(password);
            this.setState({
                strength: criteria.strength,
                criteria
            });
        }
    }

    getCriteriaClass(criteria) {
        return classnames({ "rec-criteria-check": true, "rec-criteria-passed": criteria, "rec-criteria-failed": !criteria });
    }

    renderCriteriaIcon(criteria) {
        if (criteria) {
            return (
                <span className="rec-criteria-icon">
                    <Icons.IconCheck />
                </span>
            );
        }
        else if (!criteria) {
            return (
                <span className="rec-criteria-icon">
                    <Icons.IconClose />
                </span>
            );
        }
        return null;
    }

    render() {
        const criteria = (
            <div className="rec-criteria">
                <FlexRow>
                    <FlexCol xs="variable">
                        <div className={this.getCriteriaClass(this.state.criteria.lower)}>
                            {this.renderCriteriaIcon(this.state.criteria.lower)}
                            <span className="rec-sr-only">{this.state.criteria.lower.toString()}</span>
                            One lowercase letter
                        </div>
                    </FlexCol>
                    <FlexCol xs="variable">
                        <div className={this.getCriteriaClass(this.state.criteria.upper)}>
                            {this.renderCriteriaIcon(this.state.criteria.upper)}
                            <span className="rec-sr-only">{this.state.criteria.upper.toString()}</span>
                            One uppercase letter
                        </div>
                    </FlexCol>
                    <FlexCol xs="variable">
                        <div className={this.getCriteriaClass(this.state.criteria.number)}>
                            {this.renderCriteriaIcon(this.state.criteria.number)}
                            <span className="rec-sr-only">{this.state.criteria.number.toString()}</span>
                            One number
                        </div>
                    </FlexCol>
                    <FlexCol xs="variable">
                        <div className={this.getCriteriaClass(this.state.criteria.length)}>
                            {this.renderCriteriaIcon(this.state.criteria.length)}
                            <span className="rec-sr-only">{this.state.criteria.length.toString()}</span>
                            8 characters minimum
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>
        );

        switch (this.state.strength) {
            case 4:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                        </div>
                        <div className="rec-criteria-message">
                            <strong>Password Strength: Strong.</strong> Now that&#39;s a strong password, nice job!
                        </div>
                        {criteria}
                    </div>
                );
            case 3:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-green" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                        <div className="rec-criteria-message">
                            <strong>Password Strength: Good.</strong> This is a good password, but adding a few more symbols, numbers, and characters will make it a much stronger one.
                        </div>
                        {criteria}
                    </div>
                );
            case 2:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-orange" />
                            <div className="rec-strength-line bg-orange" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                        <div className="rec-criteria-message">
                            <strong>Password Strength: Moderate.</strong> This password is acceptable, but could be stronger.  Try adding more symbols, numbers, and characters to make it better.
                        </div>
                        {criteria}
                    </div>
                );
            case 1:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-red" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                        <div className="rec-criteria-message">
                            <strong>Password Strength: Weak.</strong> This password needs some work. Use an uppercase letter, lowercase letter, number, and more characters so this password meets our minimum requirements.
                        </div>
                        {criteria}
                    </div>
                );
            default:
                return (
                    <div className="rec-strength-meter-wrapper">
                        <div className="rec-strength-meter">
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                            <div className="rec-strength-line bg-transparent" />
                        </div>
                        {criteria}
                    </div>
                );
        }
    }
}

PasswordStrengthIndicator.propTypes = {
    password: PropTypes.string
};
